const enum AuditSharingActionTypes {
  SET_MODAL = "@@AuditSharing/SET_MODAL",
  SET_SLECTED_MATTER_ID = "@@AuditSharing/SET_SLECTED_MATTER_ID",
  SET_GROUP_OWNERS_MEMBERS = "@@AuditSharing/SET_GROUP_OWNERS_MEMBERS",
}
export default AuditSharingActionTypes;
